import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { productBrief } from "../data/productBrief";
export function WorkshopsSection() {
  return <section className="section wash" id="workshops" aria-labelledby="workshops-heading" data-id="element-212" data-mp="16pmi5sj7mcrv">
      <div className="shell" data-id="element-213" data-mp="1boz4mc665htx">
        <div className="section-intro" data-id="element-214" data-mp="1bo66fzla00ne">
          <p className="eyebrow" data-id="element-215" data-mp="1bn4qphtbepzc">YOUR 5 WORKSHOPS</p>
          <h2 id="workshops-heading" data-id="element-216" data-mp="ezzuerm0y5z3">
            Five foundational skills, <span data-id="element-217" data-mp="j0jsbxef9dma">one planned session at a time</span>
          </h2>
          <p data-id="element-218" data-mp="j0th5hnqdeqe">
            Requests, listening, updates, handoffs and everyday misunderstandings. Run them in sequence or pick the skill your
            team needs next.
          </p>
        </div>
        <ol className="workshop-list" data-id="element-219" data-mp="sro6iuw9wug2">
          {productBrief.workshops.map(workshop => <li key={workshop.number} data-id="element-220" data-mp="3rg3fceoi1zsw">
              <span className="workshop-number" aria-hidden="true" data-id="element-221" data-mp="9skj0a31va0">
                {String(workshop.number).padStart(2, "0")}
              </span>
              <div data-id="element-222" data-mp="1sti1smban06w">
                <h3 data-id="element-223" data-mp="1sw47shijd7n0">{workshop.title}</h3>
                <p data-id="element-224" data-mp="1orwjglfzptpb">{workshop.outcome}</p>
              </div>
            </li>)}
        </ol>
        <div className="section-action" data-id="element-225" data-mp="1k16aky8cv8pv">
          <CtaButton href="#offer-details" data-id="element-226" data-mp="1k04xko7s4c5i">
            See the complete offer — $27 <ArrowRightIcon size={18} aria-hidden="true" data-id="element-227" data-mp="1f1k18zvnecmc" />
          </CtaButton>
        </div>
      </div>
    </section>;
}